export const FeatureTokenType = {
	DISABLE_PREROLL: 'disable_preroll',
	DISABLE_OVERLAY: 'disable_overlay',
};

export const FeatureTokenQueryParam = {
	disable_preroll: 'dp',
	disable_overlay: 'do',
};
